import * as React from 'react'
import styled from 'styled-components'

interface IState {
  isFocus: boolean
  hasValue: boolean
  value?: string
}

interface IProps extends React.InputHTMLAttributes<any> {
  color?: string
  errorMessage?: string | null | undefined | {}
  hasError?: boolean
  label?: string
  name?: string
}

const StyledContainer = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
`

const StyledInputContainer = styled.div<{
  isFocus: boolean
  hasError?: boolean
  themeColor: string
  disable?: boolean
}>`
  left: 0;
  right: 0;

  border-bottom: ${(props) => {
    if (props.hasError) return `1px solid ${props.theme.errorColor}`
    else if (props.isFocus) return `2px solid ${props.theme[props.themeColor]}`
    else return `1px solid ${props.theme.greyColor}`
  }};

  transition: border 150ms ease-out;
  outline: 0;

  &:disabled {
    background: transparent;
    border-bottom: 1px dashed ${(props) => props.theme.greyColor};
  }
`

const Label = styled.label<{ isLifted: boolean }>`
  font-size: ${(props) => props.theme.defaultFontSize};
  font-family: ${(props) => props.theme.fontFamily};
  position: absolute;
  left: 0;
  ${(props) => (props.isLifted ? 'transform: translate3d(0, -125%, 0); font-size: 85%;' : '')};
  pointer-events: none;
  transition: font-size 200ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`

const ErrorLabel = styled.label`
  font-size: calc(${(props) => props.theme.defaultFontSize} * 0.85);
  font-family: ${(props) => props.theme.fontFamily};
  color: ${(props) => props.theme.errorColor};

  min-height: 22px;

  position: relative;
`

const StyledInputFile = styled.input`
  opacity: 0;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
`

const LabelPath = styled.label`
  font-size: ${(props) => props.theme.defaultFontSize};
  font-family: ${(props) => props.theme.fontFamily};
  box-sizing: border-box;
  border: 0px;
  cursor: pointer;

  position: absolute;
`

export class InputFile extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      hasValue: !isEmpty(this.props.value),
      isFocus: false,
    }
  }

  focus = () => {
    this.setState({ isFocus: true })
  }

  blur = (e: any) => {
    this.setState({ isFocus: false })
  }

  change = (e: any) => {
    const path = e.target.value && e.target.value.split('\\')
    const value = path[path.length - 1]
    const hasValue = !isEmpty(value)

    this.setState({ hasValue, value })
    if (this.props.onChange) this.props.onChange(e)
  }

  render = () => {
    const { id, color, errorMessage, hasError, label, name, onChange, ...props } = this.props
    return (
      <StyledContainer {...props}>
        <StyledInputContainer isFocus={this.state.isFocus} hasError={hasError} themeColor={color!}>
          <StyledInputFile
            id={id}
            type="file"
            name={name}
            onFocus={this.focus}
            onBlur={this.blur}
            onChange={this.change}
            {...props}
          />
        </StyledInputContainer>
        <Label isLifted={this.state.hasValue || this.state.isFocus}>{label}</Label>
        <LabelPath>{this.state.value}</LabelPath>

        <ErrorLabel>{errorMessage}</ErrorLabel>
      </StyledContainer>
    )
  }

  static defaultProps = {
    color: 'secondaryColor',
  }
}

function isEmpty(value: any) {
  return value === '' || value === undefined || value === null || (Array.isArray(value) && value.length === 0)
}
